import React from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import RateReviewIcon from '@mui/icons-material/RateReview';
import { FormattedMessage } from 'react-intl';
import { AppMenuItemProps } from '../../AppMenuItemProps';

export const FeedbackMenuItem = ({
  classes,
  onClick
}: AppMenuItemProps): JSX.Element => {
  return (
    <MenuItem
      onClick={onClick}
      data-testid="feedback-menu"
      className={classes.menuItem}
    >
      <ListItemIcon className={classes.icon}>
        <RateReviewIcon />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage id="appMenu.feedback" />
      </ListItemText>
    </MenuItem>
  );
};
